import {IPage} from "./interfaces/IPage";
import {$} from "./Frontend";

export class FrontendPage implements IPage {
    constructor() {
        if(this.runOnCurrentPage()) {
            this.init();
            this.registerEventHandlers();
            $(() => this.onReady());
        }
    }

    protected init() {}

    runOnCurrentPage(): boolean {
        return false;
    }

    registerEventHandlers(): void {}

    onReady(): void {}
}
